// extracted by mini-css-extract-plugin
export default {"timestamp":"SupportAuthorizationActionHistory_timestamp__bvval"};